export function removeDuplicateDays(arr: any) {
  try {
    const seenDays = new Set();
    return {
      destinations: arr.map((item: any) => {
        const uniqueDays = item.no_of_day.filter((day: any) => {
          if (!seenDays.has(day)) {
            seenDays.add(day);
            return true;
          }
          return false;
        });

        return { ...item, no_of_day: uniqueDays };
      }),
    };
  } catch (err: any) {
    return { destinations: arr };
  }
}


